import SettingsLayout from "@/pages/settings/settings-layout";
import { RouteObject } from "react-router-dom";
import ApprenticeSettingsRoute from "./apprenticeship";
import MeSettingsRoute from "./me";
import CrmSettingsRoute from "./crm";
import TargetsSettingsRoute from "./targets";
import VaultSettingsRoute from "./vault";

const SettingsRoute: RouteObject = {
    path: "parametres",
    element: <SettingsLayout />,
    children: [MeSettingsRoute, ApprenticeSettingsRoute, ...CrmSettingsRoute, ...TargetsSettingsRoute, ...VaultSettingsRoute]
};

export default SettingsRoute;
